export const usaLanguageSwitcherFlagMap: Record<string, string> = {
  en: 'us'
};
